import angular from 'angular';
import { TrabalhadoresLocadosService } from './trabalhadoreslocados.service';

export const TrabalhadoresLocadosListRouting = [
    '$stateProvider',
    function ($stateProvider: angular.ui.IStateProvider): void {
        let resolve = {
            'entity': [
                'TrabalhadoresLocadosService',
                '$stateParams',
                '$state',
                '$q',
                function(
                    entityService: TrabalhadoresLocadosService,
                    $stateParams: angular.ui.IStateParamsService,
                    $state: angular.ui.IStateService,
                    $q: angular.IQService
                ): angular.ui.IStateParamsService | angular.IQService | {} {
                    if ($stateParams['entity']) {
                        return $stateParams['entity'];
                    }

                    if (!$stateParams['locado']) {
                        return {};
                    }

                    return $q((resolve: angular.IQResolveReject<any>, reject: angular.IQResolveReject<any>): void => {
                        entityService.get($stateParams['locado'])
                            .then((data: unknown): void => {
                                resolve(data);
                            })
                            .catch((error: any): void => {
                                if (error.status === 404) {
                                    if ($state.href('trabalhadores_locados_not_found', $stateParams)) {
                                        $state.go('trabalhadores_locados_not_found', $stateParams);
                                    } else {
                                        $state.go('not_found', $stateParams);
                                    }
                                }
                            });
                    });
                }
            ]
        };

        $stateProvider
            .state('trabalhadores_locados', {
                url: '/locados?q?',
                template: require('html-loader!./index/trabalhadoreslocados.index.html'),
                controller: 'TrabalhadoresLocadosIndexController',
                controllerAs: 'trabalhadores_locados_index_controller',
                reloadOnSearch: false
            })
            .state('trabalhadores_locados_show', {
                url: '/locados/:locado',
                resolve: resolve,
                template: require('html-loader!./show/trabalhadorlocado.show.html'),
                controller: 'TrabalhadorLocadoShowController',
                controllerAs: 'trabalhador_locado_show_controller'
            });
    }
];
